import { DEFAULT_ENV } from './environment.default';

export const environment = {
  ...DEFAULT_ENV,
  production: true,
  firebase: {
    apiKey: 'AIzaSyBShDoWtQpjl5mC6TeR7U_eDq0mYrSKttY',
    authDomain: 'park-test-7490a.firebaseapp.com',
    projectId: 'park-test-7490a',
    storageBucket: 'park-test-7490a.firebasestorage.app',
    messagingSenderId: '446706266918',
    appId: '1:446706266918:web:68016e785e22bdaf6807e7'
  }
};
